import { createFileRoute } from '@tanstack/react-router'

import { HealthInsuranceCpmsPage } from '../../../../../components/pages/health-insurance/cpms-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/health-insurance/cpms')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <HealthInsuranceCpmsPage />
    </PermissionChecker>
  ),
})
